// portfolioInsights.ts
// Génération des insights GHCP

export type InsightType = 'RISK' | 'OPPORTUNITY' | 'INFO';
export interface PortfolioInsight {
  type: InsightType;
  title: string;
  implication: string;
  actions: string[];
  priority: number;
}

export function generateInsightsGHCP(inputData: {
  btcDominance: number;
  stablecoinExposure: number;
  assetCount: number;
  portfolioScore: number;
  marketRegime: string;
  portfolioAlignment: number;
}): PortfolioInsight[] {
  const insights: PortfolioInsight[] = [];
  if (inputData.btcDominance > 0.8) {
    insights.push({
      type: 'RISK',
      title: 'Concentration excessive en BTC',
      implication: 'Votre portefeuille est vulnérable à une rotation vers les altcoins',
      actions: [
        'Réduire l’exposition BTC',
        'Ajouter des altcoins'
      ],
      priority: 0.9
    });
  }
  if (inputData.stablecoinExposure < 0.1) {
    insights.push({
      type: 'RISK',
      title: 'Aucune exposition aux stablecoins',
      implication: 'Vous n’avez aucun amortisseur en cas de correction du marché',
      actions: [
        'Ajouter des stablecoins'
      ],
      priority: 0.8
    });
  }
  if (inputData.assetCount <= 2) {
    insights.push({
      type: 'RISK',
      title: 'Diversification insuffisante',
      implication: 'Votre portefeuille est exposé à un risque spécifique élevé',
      actions: [
        'Ajouter de nouveaux actifs'
      ],
      priority: 0.7
    });
  }
  if (inputData.portfolioAlignment > 0.7) {
    insights.push({
      type: 'INFO',
      title: 'Portefeuille aligné avec le marché',
      implication: 'Votre allocation est cohérente avec le régime actuel',
      actions: [],
      priority: 0.3
    });
  }
  insights.sort((a, b) => b.priority - a.priority);
  return insights.slice(0, 3);
}
